var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "addCode" },
    [
      _c(
        "custom-box",
        {
          attrs: {
            title: _vm.$t("mergeServers"),
            visible: _vm.dialogShow,
            "close-on-click-modal": false,
            modal: false,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogShow = $event
            },
            close: function($event) {
              return _vm.clearData("ruleForm")
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "popover",
              attrs: {
                "label-position": "left",
                model: _vm.paramsData,
                rules: _vm.rules,
                "label-width": "130px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "mainServer", label: _vm.$t("mainServer") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectServer")
                      },
                      on: { change: _vm.serverSelect },
                      model: {
                        value: _vm.paramsData.mainServer,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "mainServer", $$v)
                        },
                        expression: "paramsData.mainServer"
                      }
                    },
                    _vm._l(_vm.serverIdList, function(item) {
                      return _c("el-option", {
                        key: item.server_id,
                        attrs: {
                          label: item.server_name,
                          value: item.server_id
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "server_id", label: _vm.$t("serverIpAddress") }
                },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        multiple: "",
                        clearable: "",
                        "collapse-tags": "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelectServer")
                      },
                      on: { change: _vm.changeSelect },
                      model: {
                        value: _vm.paramsData.serverID,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "serverID", $$v)
                        },
                        expression: "paramsData.serverID"
                      }
                    },
                    [
                      _c(
                        "el-checkbox",
                        {
                          on: { change: _vm.selectAll },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("selectAll")) + " ")]
                      ),
                      _vm._l(_vm.serverIdList, function(item) {
                        return _c("el-option", {
                          key: item.server_id,
                          attrs: {
                            label: item.server_name,
                            value: item.server_id
                          }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "areaID", label: _vm.$t("serverBelongArea") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelect")
                      },
                      model: {
                        value: _vm.paramsData.areaID,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "areaID", $$v)
                        },
                        expression: "paramsData.areaID"
                      }
                    },
                    _vm._l(_vm.serverChannel, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "config_state",
                    label: _vm.$t("configServerStatus")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelect")
                      },
                      model: {
                        value: _vm.paramsData.config_state,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "config_state", $$v)
                        },
                        expression: "paramsData.config_state"
                      }
                    },
                    _vm._l(_vm.configState, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "is_timing", label: _vm.$t("scheduledModify") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelect")
                      },
                      model: {
                        value: _vm.paramsData.is_timing,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_timing", $$v)
                        },
                        expression: "paramsData.is_timing"
                      }
                    },
                    [
                      _c("el-option", {
                        attrs: { label: _vm.$t("yes"), value: 1 }
                      }),
                      _c("el-option", {
                        attrs: { label: _vm.$t("no"), value: 2 }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.paramsData.is_timing == 1
                ? _c(
                    "el-form-item",
                    {
                      staticClass: "lodingItem",
                      attrs: {
                        prop: "time_to_run",
                        label: _vm.$t("scheduledTime")
                      }
                    },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          "popper-class": "no-atTheMoment",
                          "value-format": "timestamp",
                          type: "datetime",
                          placeholder: _vm.$t("pleaseSelectDate")
                        },
                        model: {
                          value: _vm.paramsData.time_to_run,
                          callback: function($$v) {
                            _vm.$set(_vm.paramsData, "time_to_run", $$v)
                          },
                          expression: "paramsData.time_to_run"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { label: _vm.$t("openServerTime") }
                },
                [
                  _c("el-date-picker", {
                    attrs: {
                      "popper-class": "no-atTheMoment",
                      "value-format": "timestamp",
                      type: "datetime",
                      placeholder: _vm.$t("pleaseSelectDate")
                    },
                    model: {
                      value: _vm.paramsData.OpenTime,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "OpenTime", $$v)
                      },
                      expression: "paramsData.OpenTime"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "new_tag", label: _vm.$t("isNewServer") }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelect")
                      },
                      model: {
                        value: _vm.paramsData.new_tag,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "new_tag", $$v)
                        },
                        expression: "paramsData.new_tag"
                      }
                    },
                    _vm._l(_vm.newTag, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: {
                    prop: "is_recomm",
                    label: _vm.$t("recommendServerTag")
                  }
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "flex-1",
                      attrs: {
                        clearable: "",
                        filterable: "",
                        placeholder: _vm.$t("pleaseSelect")
                      },
                      model: {
                        value: _vm.paramsData.is_recomm,
                        callback: function($$v) {
                          _vm.$set(_vm.paramsData, "is_recomm", $$v)
                        },
                        expression: "paramsData.is_recomm"
                      }
                    },
                    _vm._l(_vm.recommList, function(item) {
                      return _c("el-option", {
                        key: item.label,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "ver_max", label: _vm.$t("maxVersion") }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.ver_max,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "ver_max", $$v)
                      },
                      expression: "paramsData.ver_max"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "ver_min", label: _vm.$t("minVersion") }
                },
                [
                  _c("el-input", {
                    attrs: { placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.ver_min,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "ver_min", $$v)
                      },
                      expression: "paramsData.ver_min"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "serverIP", label: _vm.$t("mainServerIp") }
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.serverIP,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "serverIP", $$v)
                      },
                      expression: "paramsData.serverIP"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lodingItem",
                  attrs: { prop: "serverPort", label: _vm.$t("mainServerPort") }
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "", placeholder: _vm.$t("pleaseInput") },
                    model: {
                      value: _vm.paramsData.serverPort,
                      callback: function($$v) {
                        _vm.$set(_vm.paramsData, "serverPort", $$v)
                      },
                      expression: "paramsData.serverPort"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { round: "" },
                  on: {
                    click: function($event) {
                      return _vm.hiad()
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", round: "" },
                  on: {
                    click: function($event) {
                      return _vm.dataFormSubmit("ruleForm")
                    }
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("submit")) + " ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }